import Vue from 'vue';
import App from './App.vue';
import GoogleLogin from 'vue-google-login'

const gauthOption = {
    clientId: '556677160941-fm1oklv6bj2sm1ej7ml8bdsbflrgu23a.apps.googleusercontent.com',
    scope: 'profile email',
    prompt: 'select_account'
}
Vue.use(GoogleLogin, gauthOption)
new Vue({
    render: h => h(App),
}).$mount('#app')